// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../../provider/Context.bs.js";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Type_String from "../../../type/Type_String.bs.js";

function Organism_Teaser_Hover_Play(Props) {
  var href = Props.href;
  var progression = Props.progression;
  var identifier = Props.identifier;
  var screenReadersLabel = Props.screenReadersLabel;
  var programKind = Props.programKind;
  var status = Props.status;
  var match = Context.I18n.getState(undefined);
  var labels = match.labels;
  var match$1 = labels.teasers;
  var match$2 = labels.common;
  var label = progression !== undefined ? (
      progression > 0 ? match$1.continueWatching : (
          status ? match$2.moreInfos : match$1.watch
        )
    ) : (
      status ? match$2.moreInfos : match$1.watch
    );
  var icon = status || programKind !== undefined && (programKind === "INT" || programKind === "external") ? undefined : "Play";
  var style = {
    TAG: /* TeaserPlay */20,
    _0: progression,
    _1: icon
  };
  var tmp = {
    href: Curry._1(Type_String.Href.toString, href),
    label: label,
    style: style
  };
  if (identifier !== undefined) {
    tmp.identifier = identifier;
  }
  if (screenReadersLabel !== undefined) {
    tmp.screenReadersLabel = screenReadersLabel;
  }
  return React.createElement(Atom_Cta.Link.make, tmp);
}

var make = Organism_Teaser_Hover_Play;

export {
  make ,
}
/* react Not a pure module */
